module.exports = __webpack_public_path__ + "static/media/stadium_story04.a7c9a688.mp4";